import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { BlockType } from '../../@types/BlockType';
import { translation } from '../../lang/Translation';
const t = translation;

export class ConsoleOnAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.CONSOLE_ON, t.to('コンソールを表示する', 'console_show'));
    this.setNameForCode('console-on');
  }

  /**
   * ブロックの外観定義
   * @param {ブロック} block
   * @param {ブロックオブジェクト自身} self
   */
  defineBlock(block: BlockType): void {
    //タイトルつける
    ShapeSettings.setTitleField(block, this.title);

    // 属性のブロックにする
    ShapeSettings.setAttributeShape(block);
    // シーンの属性にする
    ColorSettings.setSceneColor(block);
    // 属性の入力を受け付ける
    ShapeSettings.addAttributeOfSceneStartInput(block);
    block.setOutput(true, 'SceneAttribute');
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const str = CodeSetting.getAttributeCode('data-show_console', 'true') + attribute;
    // let str =  " data-show_console ='true' " + attribute ;
    return [str];
  }
}
